import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogData } from './_models/error-dialog-data.model';

/**
 * A dialog component to display an error message
 */
@Component({
  selector: 'lm-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {
  /** The title of the error dialog */
  public title: string;

  /** The dialog error message */
  public message: string;

  /**
   * @param dialogRef - A reference to the dialog
   * @param data - The data passed to the dialog. An instance of ErrorDialogData containing the dialog's title and message
   */
  constructor(
    private dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ErrorDialogData
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  /**
   * Method called when the dialog is cancelled
   */
  onClose() {
    this.dialogRef.close();
  }
}
